import React from "react";
import { Compass, MapPin, Star, Clock } from "lucide-react";

const features = [
  {
    icon: <Compass size={20} strokeWidth={1.5} className="text-[#C17F59]" />,
    title: "Un itinéraire taillé sur mesure",
    desc: "J'écoute vos envies, je tiens compte de votre budget et de votre rythme — pour concevoir un voyage unique, pas un copié-collé de guide touristique.",
  },
  {
    icon: <Star size={20} strokeWidth={1.5} className="text-[#C17F59]" />,
    title: "Validé par un vrai passionné",
    desc: "Je relis personnellement chaque itinéraire avant qu'il vous soit livré. Passionné par l'Afrique, l'Océan Indien et l'Europe authentique, je ne valide que ce que je signerais moi-même.",
  },
  {
    icon: <MapPin size={20} strokeWidth={1.5} className="text-[#C17F59]" />,
    title: "Tout, vraiment tout inclus",
    desc: "Budget détaillé, infos pratiques, météo par mois, convertisseur de devises, liens de réservation pré-remplis.",
  },
  {
    icon: <Clock size={20} strokeWidth={1.5} className="text-[#C17F59]" />,
    title: "Votre conseiller voyage privé",
    desc: "Avec l'offre Sérénité, je connais votre itinéraire sur le bout des doigts. Posez-moi n'importe quelle question, à toute heure — je suis là.",
  },
];

export default function LandingFeatures() {
  return (
    <section className="border-y border-[#DCD4C6] py-20" style={{ background: "#F1EBE1" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-14">
          <p className="section-label mb-3">Pourquoi Voyage-r ?</p>
          <h2
            className="text-4xl sm:text-5xl"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, color: "#2B2623" }}
          >
            Une agence de voyage,{" "}
            <span className="italic" style={{ color: "#C17F59" }}>dans votre poche</span>
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="card-surface animate-fade-in-up"
              style={{ animationDelay: `${i * 100}ms` }}
              data-testid={`feature-card-${i}`}
            >
              <div className="w-10 h-10 bg-[#F9F6F0] border border-[#DCD4C6] flex items-center justify-center mb-4" style={{ borderRadius: "2px" }}>
                {f.icon}
              </div>
              <h3 className="mb-2 text-lg" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, color: "#2B2623" }}>
                {f.title}
              </h3>
              <p className="text-sm text-[#5C554E] leading-relaxed" style={{ fontFamily: "'Lora', Georgia, serif" }}>
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
